import { render, staticRenderFns } from "./VariableSelector.vue?vue&type=template&id=4d05e9b2&scoped=true"
import script from "./VariableSelector.vue?vue&type=script&lang=js"
export * from "./VariableSelector.vue?vue&type=script&lang=js"
import style0 from "./VariableSelector.vue?vue&type=style&index=0&id=4d05e9b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d05e9b2",
  null
  
)

export default component.exports